import { render } from "./EditGlobalPriceModal.vue?vue&type=template&id=06e2c672&ts=true"
import script from "./EditGlobalPriceModal.vue?vue&type=script&lang=ts"
export * from "./EditGlobalPriceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__